<template>
  <div
    class="video"
    :style="{ justifyContent: data.orientationComp === 'left' ? 'flex-start' : 'flex-end' }"
    data-cont="small"
    :data-theme="getCity === 'amsterdam' ? 'pink' : getCity === 'new-york' ? 'azure' : 'blue'"
  >
    <div class="video-player">
      <video
        crossorigin="*"
        autoplay="autoplay"
        playsinline="true"
        webkit-playsinline="true"
        loop
        muted
        @loadedmetadata="onLoadedmetadata"
        @timeupdate="onTimeUpdate"
        ref="videoplayer"
      >
        <source :src="data.url" type="video/mp4" />
      </video>

      <div class="video-player__progress">
        <div class="progress__line" :style="{ transform: `scaleX(${progress})`}"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'videoComp',

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      currentTime: 0,
      durationVideo: 0,

      handleMetadata: null,
      handleTimeupdate: null,
    };
  },

  computed: {
    progress() {
      const progress = Math.round(this.currentTime) / Math.round(this.durationVideo);
      return progress;
    },

    ...mapGetters(['getCity']),
  },

  methods: {
    onLoadedmetadata() {
      this.durationVideo = this.$refs.videoplayer.duration;
    },

    onTimeUpdate() {
      if (this.$refs.videoplayer !== undefined) this.currentTime = this.$refs.videoplayer.currentTime;

      if (this.currentTime === this.durationVideo) this.$refs.videoplayer.currentTime = 0;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/utils";

.video {
  position: relative;

  display: flex;
  align-items: flex-start;
  margin-top: 80px;

  @include mq(mobileL) {
    margin-top: 80px;
  }

  .video-player {
    position: relative;
    width: 100%;

    overflow: hidden;

    @include aspect-ratio(10, 7);

    @include mq($until: mobile, $and: $is-portrait) {
      @include aspect-ratio(1, 1);
    }

    @include mq($from: mobileL, $until: ipadP) {
      @include aspect-ratio(10, 5);
    }

    @include mq(ipadP) {
      width: calc(100% - 128px);
    }

    @include mq(ipadL) {
      @include aspect-ratio(21, 9);
    }

    &__progress {
      display: inline-block;
      position: absolute;
      bottom: 20px;
      right: 40px;
      width: 50%;
      height: 2px;

      backface-visibility: hidden;
    }

    .progress__line {
      position: relative;
      width: 100%;
      height: 4px;
      margin-top: -1px;

      transition: transform 1s linear;
      transform-origin: 0% 50%;

      @at-root [data-theme="pink"] & {
        background-color: $color-pink;
      }

      @at-root [data-theme="blue"] .progress__line {
        background-color: $color-blue;
      }

      @at-root [data-theme="azure"] .progress__line {
        background-color: $color-azure;
      }
    }
  }

  @at-root &[data-theme="pink"] {
    .progress__line,
    .video-player__progress {
      background-color: $color-pink;
    }
  }

  @at-root &[data-theme="blue"] {
    .progress__line,
    .video-player__progress {
      background-color: $color-blue;
    }
  }

  video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    object-fit: cover;
    object-position: center center;
  }
}
</style>
